var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"min-h-screen bg-gray-100"},[_vm._t("default"),_vm._v(" "),_c('toast')],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }